import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import ReducerSlice from "./reducerSlice";
import rootSaga from "./saga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    country: ReducerSlice,
  },
  middleware: [sagaMiddleware],
  devTools: process.env.NODE_ENV !== "production", 
});

sagaMiddleware.run(rootSaga);

export default store;